import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    waitTimeText: string;
    callDurationText: string;
}

const QueueCallDurations = ({ waitTimeText, callDurationText }: Props) => {
    const { i18next } = useAppContext();

    return (
        <>
            <span>
                {i18next.t('Call.Duration.InQueue', {
                    waitTime: waitTimeText,
                })}
            </span>
            <span>
                {i18next.t('Call.Duration.InCall', {
                    callDuration: callDurationText,
                })}
            </span>
        </>
    );
};

export default QueueCallDurations;
